export default "__VITE_ASSET__1ioyOIVy__"